var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasPromoData
        ? _c("PageTitle", {
            staticClass: "m-3",
            attrs: { title: _vm.personalizedWelcome }
          })
        : _c("PageTitle", {
            staticClass: "m-3",
            attrs: { title: _vm.unpersonalizedWelcome }
          }),
      _vm._v(" "),
      _c("AcknowledgeModal", { on: { acknowledged: _vm.modalAcknowledged } }, [
        _c("p", [
          _vm._v(
            "\n      We see you are responding to a letter we recently sent you in the mail.\n      Before continuing, we want to inform you that there was a clerical error in the letter you received.\n      Unfortunately, our system failed to populate the correct APR for which you pre-qualified.\n      "
          ),
          _c("b", [
            _vm._v(
              "We do not have any lenders on our platform that offer a 0.00% APR for a refinance."
            )
          ]),
          _vm._v(
            "\n      We apologize for the miscommunication and understand if you do not want to proceed with a full application,\n      which will require us to access your credit report.\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      If you do wish to see what your corrected pre-qualified rate would be — the APR\n      that should have populated in the letter you received — "
          ),
          _c("b", [
            _vm._v(
              "prior to completing an application,\n        please give us a call at "
            ),
            _c("a", { attrs: { href: "tel:+18664989990" } }, [
              _vm._v("(866) 498-9990")
            ]),
            _vm._v(" and we can check that rate for you.")
          ]),
          _vm._v(
            "\n      Note that, if you choose to apply, this may not be the APR for which you are approved,\n      depending on if you meet our criteria.\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-lg-none d-xl-none" },
        _vm._l(_vm.intentLinks, function(intent) {
          return _c(
            "div",
            { key: intent.value, staticClass: "row text-center" },
            [
              _c("div", { staticClass: "col" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-secondary rg-border-radius font-weight-bold my-2 p-3",
                    class: intent.classAddendum,
                    on: {
                      click: function($event) {
                        return _vm.clickedIntent(intent.value)
                      }
                    }
                  },
                  [
                    intent.hasOwnProperty("icon")
                      ? _c("font-awesome-icon", {
                          staticClass: "mr-2 brand-primary-color",
                          attrs: { icon: ["fas", intent.icon] }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    intent.hasOwnProperty("svg")
                      ? _c(
                          "svg",
                          {
                            staticClass:
                              "mr-2 brand-primary-color svg-inline--fa fa-search fa-w-16",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: intent.svg.viewBox,
                              fill: "#98c13d"
                            }
                          },
                          [_c("path", { attrs: { d: intent.svg.path } })]
                        )
                      : _vm._e(),
                    _vm._v("\n          " + _vm._s(intent.text) + "\n        ")
                  ],
                  1
                )
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-none d-lg-block" }, [
        _c(
          "div",
          { staticClass: "row mt-4" },
          _vm._l(_vm.intentLinks, function(intent) {
            return _c(
              "div",
              {
                key: intent.value,
                staticClass: "col",
                class: intent.classAddendum
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card shadow text-center",
                    on: {
                      click: function($event) {
                        return _vm.clickedIntent(intent.value)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card-img-top" },
                      [
                        intent.hasOwnProperty("icon")
                          ? _c("font-awesome-icon", {
                              staticClass: "mt-3 fa-2x brand-primary-color",
                              attrs: { icon: ["fas", intent.icon] }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        intent.hasOwnProperty("svg")
                          ? _c(
                              "svg",
                              {
                                staticClass:
                                  "mt-3 fa-2x brand-primary-color svg-inline--fa fa-w-20",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: intent.svg.viewBox,
                                  fill: "#98c13d"
                                }
                              },
                              [_c("path", { attrs: { d: intent.svg.path } })]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("h6", [_c("b", [_vm._v(_vm._s(intent.text))])])
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.testing === true
        ? _c("button", { on: { click: _vm.goToThanks } }, [
            _vm._v("\n    Go To Thanks\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPreviousRouteName
        ? _c(
            "div",
            { staticClass: "pt-5 text-center" },
            [
              _c("InformationSecure", { staticClass: "font-weight-light" }),
              _vm._v(" "),
              _c("NavigationButton", {
                attrs: { color: "btn-outline-primary", text: "Back" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: _vm.previousRouteName })
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }